export default __webpack_public_path__ + "static/media/logo_light.12361409.png";